var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Pipe } from '@angular/core';
import { AmendType } from '../../enums/workload/amend-type';
var AmendTypePipe = /** @class */ (function () {
    function AmendTypePipe() {
    }
    AmendTypePipe.prototype.transform = function (formAction) {
        switch (formAction) {
            case (AmendType.NotSet):
                {
                    return 'Not Set';
                }
            case (AmendType.MissingUnits):
                {
                    return 'Missing Units';
                }
            case (AmendType.MissingCriteria):
                {
                    return 'Missing Criteria';
                }
            case (AmendType.MissingData):
                {
                    return 'Missing Date';
                }
            case (AmendType.RulesOfCombinationIncBarredUnits):
                {
                    return 'Rules of Combination (Inc Barred Units)';
                }
            case (AmendType.CreditValues):
                {
                    return 'Credit Values';
                }
            case (AmendType.IncorrectCriteria):
                {
                    return 'Incorrect Criteria';
                }
            case (AmendType.SpellingErrors):
                {
                    return 'Spelling Errors';
                }
            case (AmendType.IncorrectGrouping):
                {
                    return 'Incorrect Grouping';
                }
            case (AmendType.Numbering):
                {
                    return 'Numbering';
                }
            case (AmendType.QualificationType):
                {
                    return 'Qualification Type';
                }
            case (AmendType.UpdatesVersionAndDateChange):
                {
                    return 'Updates (version and date change)';
                }
            case (AmendType.AddingExtraCriteria):
                {
                    return 'Adding extra criteria';
                }
            case (AmendType.ChangingNumbering):
                {
                    return 'Changing Numbering';
                }
            case (AmendType.UnitReference):
                {
                    return 'Unit Reference';
                }
            case (AmendType.ChangesToBespokeQualifications):
                {
                    return 'Changes to Bespoke Qualifications';
                }
            case (AmendType.FrontPageAmendment):
                {
                    return 'Front Page Amendment';
                }
            case (AmendType.SeparatingLists):
                {
                    return 'Separating lists';
                }
            case (AmendType.UngroupingCriteria):
                {
                    return 'Ungrouping Criteria';
                }
            case (AmendType.BulletPointSeparateToFirstOutcome):
                {
                    return 'Bullet point separate to first outcome';
                }
            case (AmendType.Rebuild):
                {
                    return 'Rebuild';
                }
        }
    };
    AmendTypePipe = __decorate([
        Pipe({ name: 'amendType' })
    ], AmendTypePipe);
    return AmendTypePipe;
}());
export { AmendTypePipe };
//# sourceMappingURL=data:application/json;base64,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